import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
//api
import { getAllUsers } from 'api/users';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchUserInput = ({ 
  onSelected, 
  defaultUser = null, 
  placeholder 
}) => {
  const { t } = useTranslation(['backoffice']);
  const [userSelected, setUserSelected] = useState(null);

  useEffect(() => {
    if (defaultUser) {
      setUserSelected({
        label: defaultUser.full_name,
        value: defaultUser.id,
      });
    } else setUserSelected(null)
  }, [defaultUser]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getAllUsers({ full_name: value, page: 1, page_size: 10 });
      if (status === 200) {
        return data?.results?.map((item) => ({
          ...item,
          label: item.full_name,
          value: item.id,
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      defaultOptions={userSelected ? [userSelected] : []}
      defaultValue={userSelected}
      label={t('user')}
      placeholder={placeholder || t('searchByName')}
      onSelect={onSelected}
      onSearch={onSearch}
    />
  );
};

SearchUserInput.propTypes = {
  onSelected: PropTypes.func.isRequired,
  defaultUser: PropTypes.object,
  placeholder: PropTypes.string,
};

export default SearchUserInput;
